export var ENVIRONMENTS;
(function (ENVIRONMENTS) {
    ENVIRONMENTS["PRODUCTION"] = "PRODUCTION";
    ENVIRONMENTS["STAGE"] = "STAGE";
})(ENVIRONMENTS || (ENVIRONMENTS = {}));
